import { lazy } from 'react';

export const LazyTemplateGalleryPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--template-gallery-page" */ './template-gallery-page'
    ),
);
